module.exports = __webpack_public_path__ + "static/preview-sm-1-a847230f71b23188f2ee72fff176cc7b.jpg";